import { Loader2 } from "lucide-react";
import { apiCall } from "../../../src/lib/api";
import React from "react";
import { ReloadIcon } from "@radix-ui/react-icons";

interface rate {
  HasErrors: boolean;
  Notifications: {
    Notification: [{ Code: string; Message: string }];
  };
  TotalAmount: {
    Value: number;
    CurrencyCode: string;
  };
  Transaction: [];
}
export default function AramexRateCalculator({
  city,
  country,
  weight,
  pieces,
  paymentType,
  address,
  postCode,
  setRate,
}: {
  city: string;
  country: string;
  weight: number;
  pieces: number;
  address: string;
  paymentType: string;
  postCode: string;
  setRate: (e: string) => void;
}) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [calculatedRate, setCalculatedRate] =
    React.useState<rate>();
  async function fetchAramexRate() {
    setIsLoading(true);
    try {
      const res = await fetch(
        `${apiCall}/wp-json/aramex/v1/calculate-rate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Line1: address,
            origin_city: "Chtaura",
            origin_country: "LB",
            PostCode: postCode,
            destination_city: city || "Chtaura",
            destination_country: country,
            weight: { Value: weight / 1000, Unit: "KG" },
            pieces: pieces,
            zip_code: postCode,
            product_group: country === "LB" ? "DOM" : "EXP",
            product_type: country === "LB" ? "OND" : "PPX",
            payment_type:
              paymentType === "cash" ? "C" : "P",
          }),
        }
      );

      if (!res.ok) {
        setIsLoading(false);
        console.log(`HTTP error: ${res.status}`);
      }

      const data = await res.json();
      setIsLoading(false);
      console.log("Rate data:", data);
      setCalculatedRate(data);
      setRate(data.TotalAmount?.Value); // Handle the fetched data as needed
      return data;
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching rate:", error);
    }
  }
  React.useEffect(() => {
    fetchAramexRate();
  }, [city, country]);

  return (
    <div className="flex gap-5 w-full justify-between">
      <div className="flex flex-col gap-1 justify-center items-start">
        <span className="text-sm">SHIPPING</span>
        <img
          src="/aramex-logo.webp"
          alt="aramex"
          className="w-16 dark:bg-white"
        />
      </div>
      {isLoading ? (
        <Loader2 className="animate-spin duration-700 size-4" />
      ) : (
        <div>
          {calculatedRate?.HasErrors === true ? (
            <div className="flex gap-1 justify-center items-center">
              <button
                onClick={() => fetchAramexRate()}
                className="flex justify-center items-center"
              >
                <ReloadIcon className="stroke-3 size-3" />
              </button>
              <span>
                {
                  calculatedRate?.Notifications
                    ?.Notification[0]?.Code
                }
              </span>
            </div>
          ) : (
            <div className="flex gap-1 justify-center items-center">
              <button
                onClick={() => fetchAramexRate()}
                className="flex justify-center items-center"
              >
                <ReloadIcon className="stroke-3 size-3" />
              </button>
              <span className="font-bold">
                {calculatedRate?.TotalAmount?.Value + "$"}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
